import React, { useEffect, useState } from "react";
import Styles from "../../../Styles/Banking/bankingList.module.css";
import bankingService from "../../../components/Services/banking.service";

const BankingList = ({ item, received, placed }) => {
  console.debug(received);
  const [activeState, setActiveState] = useState("RECEIVED");

  return (
    <></>
  );
};

export default BankingList;
